import styled from 'styled-components'

const SdfContainer = styled.div`
  display: flex;
  margin-left: 33px;
  padding: 10px 0;
`

const InfoIcon = styled.div`
  width: 20px;
  display: flex;
  margin-right: 5px;
`

const DrawerLink = styled.span`
  color: ${props => props.theme.color.palette['brand-1']};
  font-weight: ${props => props.theme.font.weight.bold};
  text-decoration: underline;
  cursor: pointer;

  &:hover,
  &:active {
    color: ${props => props.theme.color.palette['brand-1-dark']};
  }
`

export { SdfContainer, InfoIcon, DrawerLink }
